export default "__VITE_ASSET__bdc3ed3d__"